// extracted by mini-css-extract-plugin
export default {"block__two":"thisDayInfo_block__two__nfSIo","block__two__inner":"thisDayInfo_block__two__inner__YyffR"};